module.exports = __webpack_public_path__ + "img/close.7e063ef3.svg";